export default __webpack_public_path__ + "static/media/Badminton Hall, PKL1.2b238741.jpg";